<template>
  <div class="content">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>课程</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/classservice/class' }">课程待办</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="button-wrap">
        <el-button size="small"
                   type="primary"
                   @click="handleToLog()">新建</el-button>
      </div>
    </div>
    <el-card style="margin-top: 20px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query"
               size="small"
               label-position="left">

        <el-form-item label="课程名称">
          <el-input v-model.trim="query.course_name_keyword"
                    placeholder="请输入课程名称"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="card-header">
        <TableTittle :title="TableName"></TableTittle>
        <el-form label-width="70px"
                 size="small"
                 style="margin-bottom:0px;display:flex;"
                 label-position="right">
          <el-form-item label-width="32px">
            <el-radio-group v-model="query.statuses"
                            @change="fetchList(true)">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button :label="1">上架</el-radio-button>
              <el-radio-button :label="0">下架</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="result"
                :header-cell-style="{
          textAlign: 'center',
          color: '#909399',
          fontFamily: 'PingFang SC',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: '#F2F6FC',
        }"
                :cell-style="{ fontSize: '13px' }"
                @selection-change="handleSelectionChange"
                border>
        <el-table-column type="selection"
                         width="50"
                         align="center">
        </el-table-column>
        <el-table-column label="ID"
                         prop="id"
                         align="center"
                         width="90">
        </el-table-column>
        <el-table-column label="课程年份"
                         width="120"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.year }}年

          </template>
        </el-table-column>
        <el-table-column label="课程名称"
                         width="400"
                         align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.course_name }}
          </template>
        </el-table-column>

        <el-table-column label="课程状态"
                         width="90"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1"
                    size="mini"
                    type="success">上架</el-tag>
            <el-tag v-if="scope.row.status == 0"
                    type="danger"
                    size="mini">下架</el-tag>

          </template>
        </el-table-column>
        <el-table-column label="关联待办"
                         width="200"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.ref_course_todo_all_count }}条
          </template>
        </el-table-column>
        <el-table-column label="创建人"
                         width="200"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.creator_nickname }}

          </template>
        </el-table-column>
        <el-table-column label="创建日期"
                         align="center"
                         width="250">
          <template slot-scope="scope">
            {{
              scope.row.create_time
                ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="修改日期"
                         align="center"
                         width="250">
          <template slot-scope="scope">
            {{
              scope.row.update_time
                ? $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
                : ""
            }}
          </template>
        </el-table-column>

        <el-table-column prop="name"
                         label="操作"
                         width="200"
                         align="center"
                         fixed="right">
          <template slot-scope="scope">
            <div class="templateLink">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToEdit(scope.row)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToMange(scope.row)">管理</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 16px">
        <el-button size="mini"
                   type="danger"
                   @click="handleToDeleteAll()">批量删除</el-button>

        <div class="block">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </el-card>
    <AddCourse :isVisible="addVisible"
               @close="addClose"
               @submit="fetchList()"
               :title="title"
               :detail="detail"> </AddCourse>
  </div>
</template>
  
  <script>
import TableTittle from '../../../components/TableTittle/TableTittle.vue'
import AddCourse from '@/components/DialogComponents/ClassService/AddCourse'
import { courseList, courseDelete } from '@/request/api'

export default {
  components: {
    TableTittle,
    AddCourse,
  },
  data() {
    return {
      TableName: '课程列表',
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        statuses: 1,
      },
      result: [],
      chooseList: [],
      addVisible: false,
      pageTotal: 0,
      title: '',
      detail: {},
      filter: {
        status: [
          {
            name: '上架',
            id: '0',
          },
          {
            name: '下架',
            id: '1',
          },
        ],
      },
    }
  },
  created() {
    this.fetchList()
  },

  computed: {},
  methods: {
    fetchList(isReset = false) {
      const params = Object.assign({}, this.query)
      if (isReset == true) {
        params.pageIndex = 1
      }
      courseList(params).then((response) => {
        let res = response.data
        this.result = res.data.list || []
        this.pageTotal = res.data.count
      })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToLog() {
      this.title = '新建'
      this.addVisible = true
    },
    handleToEdit(row) {
      this.detail = row
      this.title = '编辑'
      this.addVisible = true
    },
    addClose() {
      this.addVisible = false
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.fetchList()
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.fetchList()
    },

    handleToMange(row) {
      this.$router.push(`/classservice/CourseDoneMange/${row.id}`)
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('至少选择一条数据！')
        return
      }

      this.$confirm('确定要删除此条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then((res) => {
        console.log('this.chooseList', this.chooseList)
        let ids = []
        this.chooseList.map((item) => {
          ids.push(item.id)
        })
        console.log('ids', ids)
        courseDelete({ ids }).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('删除成功')
            this.fetchList()
          }
        })
      })
    },
  },
}
</script>
  
  <style lang="less" scoped>
.img-list {
  margin-top: 12px;
  display: flex;
  align-items: center;

  img {
    width: 140px;
    height: 140px;
    margin-right: 12px;
    border-radius: 4px;
  }
}
.dropdown-item {
  height: 100%;
  width: 100%;
}
/deep/.el-badge__content {
  z-index: 999999;
}
.count-wrap {
  padding: 30px 0px;
  background: #ecf2fe;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .label {
      margin-bottom: 12px;
    }
    .value {
      font-size: 28px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .red {
      color: #f36d78;
    }
  }
}
</style>
  